export const TransportDocumentActiveStatus = {
  NEW: 0,
  SENT: 1,
  ARRIVED: 2
};
